import { render, staticRenderFns } from "./AkunSidebar.vue?vue&type=template&id=2d05748d&scoped=true&"
import script from "./AkunSidebar.vue?vue&type=script&lang=js&"
export * from "./AkunSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AkunSidebar.vue?vue&type=style&index=0&id=2d05748d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d05748d",
  null
  
)

export default component.exports